export const toggleSubmitButton = () => {
  const validate = $('.validate-form').validate();

  if (validate != null) {
    $('.btn-submit').prop('disabled', !validate.checkForm());
    validate.submitted = {};
  }
};
